import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import * as AT from "./actionTypes";
import * as SELECTORS from "./selectors";
import { RootState } from "../../../../models";
import * as Ajax from "../../app/Ajax";
import { API_URL_UPDATE_PORTING_DATES } from "../api";

export const setSelectedDate = (date: Date, guid: string) => ({
    type: AT.UPD_SET_SELECTED_DATE,
    date,
    guid,
});

export const updatePortingDates =
    (orderItemGuid: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    async (dispatch, getState) => {
        const state = getState();
        const dates = SELECTORS.getUpdatedPortingDates(state);

        return dispatch({
            type: AT.UPD_UPDATE_PORTING_DATES,
            payload: Ajax.post(
                {
                    url: API_URL_UPDATE_PORTING_DATES,
                    data: {
                        dates,
                        orderItemGuid,
                    },
                },
                dispatch,
            ),
        });
    };
